import React, { ReactNode } from 'react';

import { classNames } from '../../utils/style';
import { textBody } from '../../styles/typography';

export interface ComparisonTableHeaderProps {
  className?: string;
  headers: string[];
}
export const Header = ({ className, headers }: ComparisonTableHeaderProps) => {
  return (
    <thead className={classNames('ComparisonTableHeader', className)}>
      <tr className={classNames('flex flex-row items-center')}>
        <th className="w-208 lg:w-300"></th>
        {headers.map((header: ReactNode, key: number) => (
          <th
            key={key}
            className={classNames(
              textBody,
              'py-16 text-neutral-301',
              'font-normal flex-1'
            )}
          >
            {header}
          </th>
        ))}
      </tr>
    </thead>
  );
};
